import type { ChangeEvent } from "react";
import { useEffect, useRef, useState } from "react";
import { Form } from "~/components/blocks/layout/global-navi/mobile/right/search-form/form";
import { HistoryList } from "~/components/blocks/layout/global-navi/mobile/right/search-form/history-list";
import { useMobileSearchForm } from "~/components/blocks/layout/global-navi/mobile/right/search-form/hooks/use-mobile-search-form";
import { useFade } from "~/hooks/use-fade";
import { useViewableRatingBlock } from "~/hooks/use-viewable-rating-block";

type SearchFormV2Props = {
  /** キーワード */
  keyword: string;
  /** キーワード更新関数 */
  onChangeKeyword: (e: ChangeEvent<HTMLInputElement>) => void;
  /** キーワード上書き関数 */
  onOverWriteKeyword: (text: string) => void;
  /** 検索履歴表示状態 */
  isShowSearch: boolean;
  /** 検索履歴非表示処理 */
  onHideSearch: () => void;
};

export const SearchForm = (props: SearchFormV2Props) => {
  const { isShowSearch, keyword, onHideSearch, onOverWriteKeyword, onChangeKeyword } = props;
  const searchInputRef = useRef<HTMLLabelElement>(null);
  const [isShowHistoryList, setIsShowHistoryList] = useState(false);
  const { isDisplay: isVisibleHistoryList } = useFade(isShowHistoryList, 150);
  const { isAdultLinkAllowed } = useViewableRatingBlock();

  const onVisibleSearchList = () => setIsShowHistoryList(true);
  const onHideHistoryList = () => setIsShowHistoryList(false);
  const {
    searchHistories,
    onChangeAndSearchKeyword,
    onRemoveHistory,
    onClickClearButton,
    onUpdateKeyword,
    onCancel,
    onBrowserBack,
    onBlurSearchForm,
    pushToVideoList,
  } = useMobileSearchForm({
    searchInputRef,
    keyword,
    onOverWriteKeyword,
    onChangeKeyword,
    onHideHistoryList,
    onVisibleSearchList,
    onHideSearch,
  });

  useEffect(() => {
    const browserBackListener = () => {
      if (isShowSearch) {
        onBrowserBack();
      }
    };
    window.addEventListener("popstate", browserBackListener, { passive: true });
    return () => {
      window.removeEventListener("popstate", browserBackListener);
    };
  }, []);

  return (
    <>
      <Form
        searchInputRef={searchInputRef}
        isShowSearch={isShowSearch}
        keyword={keyword}
        onCancel={onCancel}
        onChangeText={onChangeAndSearchKeyword}
        onClickClearButton={onClickClearButton}
        onBlur={onBlurSearchForm}
      />

      {isVisibleHistoryList && (
        <HistoryList
          searchInputRef={searchInputRef}
          isShowHistoryList={isShowHistoryList}
          searchHistories={searchHistories}
          isViewableUnrestricted={isAdultLinkAllowed}
          onHideSearch={onHideSearch}
          onRemoveHistory={onRemoveHistory}
          onHideHistoryList={onHideHistoryList}
          onUpdateKeyword={onUpdateKeyword}
          pushToSearch={pushToVideoList}
        />
      )}
    </>
  );
};
